import {connect} from 'react-redux';
import LabPartnersContainer from './LabPartnersContainer';

interface State {
    textEnums: {
        labPartners: {
            [key: string]: string;
        };
    };
}
export const mapState = (state: State) => ({
    labPartners: state.textEnums?.labPartners || {},
});

export default connect(mapState)(LabPartnersContainer);
